<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <div class="border-b border-gray-200">
            <nav class="flex space-x-6 px-4" aria-label="Tabs">
            <div :class="[(currentRoute === 'info') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('info')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Practitioner Information</div>
              </div>
            </div>
            <div v-if="data.status === 'APPROVED'" :class="[(currentRoute === 'annual-returns') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('annual-returns')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Annual Returns</div>
              </div>
            </div>
            <div :class="[(currentRoute === 'attachments') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('attachments')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Filing History</div>
              </div>
            </div>
            <div v-if="data.status !== 'APPROVED'" :class="[(currentRoute === 'messages') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('messages')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Messages</div>
              </div>
            </div>
            <div v-if="data.status !== 'ASSIGNED'" :class="[(currentRoute === 'complaints') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('complaints')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Complaints</div>
              </div>
            </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 my-2">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4" v-if="currentRoute === 'info'">
            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-4 mt-4">
                <div class="col-span-7">
                  <span class="h5">Bio</span>
                </div>
                <div class="col-span-5">
                  <span class="h5">Professional Conduct</span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-7">
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="data.firstName +' '+ data.lastName"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-xs noFocus"                          id="companyName"


  :disabled="true"
                          :value="data.email"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="data.phoneNumber"
                          required>
                        </input>
                      </div>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="data.gender"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="dateFormat(data.dateOfBirth)"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="data.postalAddress"
                          required>
                        </input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-span-5">
                  <div class="grid grid-cols-12 gap-4 mt-3">
                    <div class="col-span-10">
                      <span class="text-sm">Applicant Subjected To Any Disciplinary Proceedings</span>
                    </div>
                    <div class="col-span-2">
                      <span class="font-bold" v-if="isDisciplined">YES</span>
                      <span class="font-bold" v-else>NO</span>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-10">
                      <span class="text-sm">Applicant Disqualified From Practicing Insolvency</span>
                    </div>
                    <div class="col-span-2">
                      <span class="font-bold" v-if="isDisqualified">YES</span>
                      <span class="font-bold" v-else>NO</span>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-10">
                      <span class="text-sm">Applicant Subjected to Any Prohibition Under the Law</span>
                    </div>
                    <div class="col-span-2">
                      <span class="font-bold" v-if="isProhibited">YES</span>
                      <span class="font-bold" v-else>NO</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-12 gap-4 mt-4">
                <div class="col-span-12">
                  <span class="h5">Address</span>
                </div>
                <div class="col-span-12">
                  <span class="h5">Bank Information</span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <div class="grid grid-cols-12 gap-4" v-if="address">
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="address.country.name"
                          required>
                        </input>
                      </div>
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="address.district.name"
                          required>
                        </input>
                      </div>
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="address.parish.name"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="address.region.name"
                          required>
                        </input>
                      </div>
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="address.subcounty.name"
                          required>
                        </input>
                      </div>
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="address.village.name"
                          required>
                        </input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-span-12">
                  <div class="grid grid-cols-12 gap-4" v-for="(bank, idx) in data.bankAccountInformation" :key="idx">
                    <div class="col-span-3">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="bank.bankName"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-6">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="bank.accName"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-3">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="bank.accNo"
                          required>
                        </input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-12 gap-4 mt-4">
                <div class="col-span-12">
                  <span class="h5">Qualification(s)</span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <div class="grid grid-cols-12 gap-4" v-for="(item, idx) in data.qualifications" :key="idx">
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                            id="companyName"


  :disabled="true"
                            :value="item.awardType"
                            required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.award"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.awardingBody"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.year"
                          required>
                        </input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-12 gap-4 mt-4">
                <div class="col-span-12">
                  <span class="h5">Profession(s)</span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <div class="grid grid-cols-12 gap-4" v-for="(item, idx) in data.professions" :key="idx">
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.professionName"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.professionBody"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.memberShipId"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="dateFormat(item.expiryOfMemberShip)"
                          required>
                        </input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-12 gap-4 mt-4">
                <div class="col-span-12">
                  <span class="h5">Indemnity</span>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <div class="grid grid-cols-12 gap-4" v-for="(item, idx) in data.indemnity" :key="idx">
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.insurancePolicyHolder"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                            id="companyName"


  :disabled="true"
                            :value="item.insurer"
                            required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="item.valueOfInsurance"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="dateFormat(item.dateOfIssuance)"
                          required>
                        </input>
                      </div>
                    </div>
                    <div class="col-span-12">
                      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                          id="companyName"


  :disabled="true"
                          :value="dateFormat(item.expiryOfInsurance)"
                          required>
                        </input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4" v-if="currentRoute === 'attachments'">
            <div class="col-span-5 mb-3">
              <div class="grid grid-cols-12 gap-4" v-if="data != null">
                <div class="col-span-12">
                  <div class="grid grid-cols-12 gap-4 mb-4" v-for="(form, idx) in form1s" :key="idx">
                    <div class="col-span-12">
                      <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                        <thead>
                        <tr class="bg-gray-pale">
                          <td v-if="form.status.toUpperCase() === 'APPROVED'" colspan="12" class="px-2 py-2 font-bold text-capitalize">{{ form.applicationType.toLowerCase() }} Documents - {{ form1Year(form) }}</td>
                          <td v-else colspan="12" class="px-2 py-2 font-bold text-capitalize">{{ form.applicationType.toLowerCase() }} Attachments - {{ form1Year(form) }}</td>
                        </tr>
                        <tr>
                          <th class="px-2 py-1">#</th>
                          <th class="px-2 py-1">File Name</th>
                          <th class="px-2 py-1 float-end">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(file, idx) in form.form1AttachmentList" :key="idx" style="border: solid 1px #dedede;">
                          <td class="px-2 py-1">{{idx + 1}}</td>
                          <td class="px-2 py-1 text-capitalize">{{cleanName(file.insolvencyDocument.replace(".PDF", ""))}}</td>
                          <td class="px-2 py-1">
                            <button class="btn-primary float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="openFile(file)">Show</button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-7">
              <PractitionerAttachments ref="attachmentScreen"/>
            </div>
          </div>
          <PractitionerFilingMessages v-if="currentRoute === 'messages'"/>
          <PractitionerComplaints
              v-if="currentRoute === 'complaints' && data.status !== 'ASSIGNED'"
              :upn="props.upn || ''"
              :name="practitionerFullName || ''"
              :gender="practitionerGender"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useSettingsStore } from "@/stores/settings";
import { dateFormat } from "@/commons/composables/utilities";
import PractitionerAttachments from "@/domains/home/services/registry/practitioners/PractitionerAttachments.vue";
import PractitionerFilingMessages from "@/domains/home/services/registry/practitioners/PractitionerFilingMessages.vue";
import PractitionerComplaints from "@/domains/home/services/registry/practitioners/PractitionerComplaints.vue";
import { Form1 } from "@/domains/home/services/registry/practitioners/types";

const props = defineProps({
  data: {
    type: Object,
    default: null
  },
  upn: String,
  form1s: {
    type: Array as () => Form1[],
    required: true
  }
});

const settingsStore = useSettingsStore();

const currentRoute = ref("info");
const attachmentUrl = ref<string | null>(null);
const address = ref<any>(null);
const attachmentScreen = ref<InstanceType<typeof PractitionerAttachments> | null>(null);

const select = (route: string) => {
  currentRoute.value = route;
};

const openFile = (data: any) => {
  attachmentUrl.value = import.meta.env.VITE_API_BASE_URL + "/insolvency/api/practitioner-registration/attachment/" + data.filename;
};

const cleanName = (name: string) => {
  return name.replaceAll(".pdf", "");
};

const form1Year = (form: any) => {
  return new Date(form.registrationDate).getFullYear();
};

const practitionerGender = computed(() => {
  if ((props.form1s as any[]).length === 0) {
    return null;
  }
  return (props.form1s as any[])[0].gender;
});

const practitionerFullName = computed(() => {
  if ((props.form1s as any[]).length === 0) {
    return null;
  }
  return `${(props.form1s as any[])[0].firstName} ${(props.form1s as any[])[0].lastName}`;
});

const isDisciplined = computed(() => {
  if (props.data === null) {
    return false;
  }
  return props.data?.profConductDetails?.find((c: any) => {
    return c.subjection === "SUBJECTED_TO_DISCIPLINARY_PROCEEDING" && c.detailedInformation !== null;
  }) !== undefined;
});

const isProhibited = computed(() => {
  if (props.data === null) {
    return false;
  }
  return props.data?.profConductDetails?.find((c: any) => {
    return c.subjection === "SUBJECTED_TO_PROHIBITION" && c.detailedInformation !== null;
  }) !== undefined;
});

const isDisqualified = computed(() => {
  if (props.data === null) {
    return false;
  }
  return props.data?.profConductDetails?.find((c: any) => {
    return c.subjection === "DISQUALIFIED_FROM_INSOLVENCY" && c.detailedInformation !== null;
  }) !== undefined;
});

watch(() => props.data, (d) => {
  if (d !== null) {
    settingsStore.fetchAddressByVillageId(d.villageId);
  }
}, { deep: true });

watch(() => settingsStore.address, (data) => {
  address.value = data?.data ?? null;
});

watch(attachmentUrl, (url) => {
  if (url && attachmentScreen.value) {
    attachmentScreen.value.openFile(url);
  }
}, { deep: true });
</script>
